
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Picker from 'vux/src/components/picker/index.vue'

import  { common, commonApi, check }  from '@/common/index';
import { validataPhone, checkOne, ValidateRequire, validataBank, validataDrawPwd } from '@/common/utils/validate.js'
import { mapState, mapActions } from 'vuex';
export default {
name: 'addBankCard',
directives: { TransferDom },
components: { XButton, Group, XInput, Confirm, PopupPicker, Picker },
data() {
return {
ruleForm: {
UUID: '',
personName : '',
bankName : '',
cardNumber: '',
subBank : '',
bankBindPhone: '',
withdrawPassword : '',
bankCode: '',
},
bankName: [],
bankNameList: [], // 银行名称列表
showWithdrawalPassword: false,
passwordTip: false,
submitloading: false,
}
},
computed: {
...mapState({
userInfo: state => state.userInfo.userInfo,
withdrawPasswordValid: state => state.userInfo.userInfo.withdrawPasswordValid,
isLogin: state => state.isLogin,
serverInfo: state => state.userInfo.serverInfo
})
},
created() {
if (this.userInfo.nameValid) this.ruleForm.personName = this.userInfo.name
if (!!this.userInfo.mobilePhone) this.ruleForm.bankBindPhone = this.userInfo.mobilePhone
this.ruleForm.UUID = this.$Cookies.get('UUID');


this._getBankNameList()
},
methods: {
...mapActions([ 'getFirstInfo' ]),
haveComToast(data,istype){
this.$vux.toast.show({ text: data, type: istype});
},
_bankNameSelect(v) {
const { name, value } = this.bankNameList.filter((item) => (item.value === v[0]))[0]
this.ruleForm.bankName = name
this.ruleForm.bankCode = value
},
_getBankNameList() { // 获取银行名称列表
this.bankNameList = []
this.$api.post(this.$urls.PAY.bankNameList,{ UUID: this.ruleForm.UUID },resp=>{
const { data, code } = resp.data
if(code === 200) {
data.forEach((item) => {
const { bank_name, bank_code, logo } = item
this.bankNameList.push({ name: bank_name, value: bank_code, logo })
})
}
},err=>{})
},

















onCancel(){},
onConfirm(){ // 确定去设置账户信息
this.$router.push({ path:'/My/AccountManat' })
},
onShow(){},
onHide(){},
addBank() {
if (!this.checkForm()) return
this.submitloading = true;
commonApi.PAY.addBank(this.ruleForm).then(data=>{
this.submitloading = false;
this.haveComToast(this.$t('mine').bindSuccess,'success') 
this.getFirstInfo();
this.$router.replace({path: '/My/Withdrawal/withdrawal'})
this.$store.dispatch('refreshUserInfo')
}).catch(err=>{
this.submitloading = false;
this.haveComToast(err,'cancel')
})
},
checkForm(){
const { personName, bankName, cardNumber, subBank, bankBindPhone, withdrawPassword } = this.ruleForm
if(check.checkRealname(personName) || (this.userInfo.nameValid && (personName !== this.userInfo.name))){ //检验账号
this.haveComToast(this.$t('mine').Withdrawal.addbankcard.personNamePlace, 'cancel')
return
}
if(!ValidateRequire(bankName)){
this.haveComToast(this.$t('mine').Withdrawal.addbankcard.bankNamePlace, 'cancel')
return
}
if(!validataBank(cardNumber)){
this.haveComToast(this.$t('mine').Withdrawal.addbankcard.cardNumberError, 'cancel')
return
}
if (!ValidateRequire(subBank)) {
this.haveComToast(this.$t('mine').Withdrawal.addbankcard.bankBranchPlace, 'cancel')
return
}
if (this.$store.state.linkList.withdrawMethod !== '1' && !validataPhone(bankBindPhone)) {
this.haveComToast(this.$t('mine').Withdrawal.addbankcard.bankBindPhonePlace, 'cancel')
return
}
if (this.$store.state.linkList.withdrawMethod !== '1' && !validataDrawPwd(withdrawPassword)) {
this.haveComToast(this.$t('Forms').drawPwdError, 'cancel')
return
}
return true
}
}
};



// WEBPACK FOOTER //
// ./src/pages/build800/views/My/Withdrawal/addbankcard.vue